<template>
	<div class="goodWrap" @click="clooseBtn">
		<!-- PDF 预览 -->
		<div v-if="showPdf" class="pdf-wrap" @click="closePdf">
			<div class="pdf-header" @click.stop>
				<van-icon name="cross" size="1.5rem" color="#fff" @click="closePdf" />
			</div>
			<div class="pdf-body" :class="{ 'pdf-body--loaded': pdfLoaded }" @click.stop>
				<div ref="pdfContainerRef" class="pdf-viewer"></div>
			</div>
		</div>

		<!-- 导航栏 -->
		<TabNavBar v-show="!hideTab" id="barList" ref="navBarRef" title="">
			<template #left>
				<div class="custom-back" @click.stop="goBack">
					<div class="back-btn">
						<i class="iconfont icon-maijia_zuojin" style="color: #595959; font-size: 1.33rem"></i>
					</div>
				</div>
			</template>
			<template #default>
				<div class="seg-tabs">
					<div
						v-for="(item, idx) in controlItems"
						:key="idx"
						:class="['seg-tab', { 'seg-tab--active': current === idx }]"
						@click="onClickItem({ currentIndex: idx })"
					>
						{{ item }}
					</div>
				</div>
			</template>
			<template #right>
				<div style="height: 3.67rem; display: flex; align-items: center" @click.stop="dropDown">
					<van-icon name="ellipsis" size="2.4rem" color="#999" />
				</div>
				<DropDown class="dialogBox" id="more-oprate" :show="show" goodDetail="goodDetail" />
			</template>
		</TabNavBar>

		<!-- hideTab 时固定返回按钮 -->
		<div v-if="hideTab" class="back-btn-fixed" @click="goBack">
			<div class="back-btn">
				<i class="iconfont icon-maijia_zuojin" style="color: #595959; font-size: 1.33rem"></i>
			</div>
		</div>

		<!-- 主滚动区域 -->
		<div ref="scrollRef" class="scrollContent" :class="{ hidePaddingTop: hideTab }" @scroll="scrollChange">
			<!-- 商品主内容 -->
			<div class="contentGood" id="md1">
				<div class="goodBox">
					<van-swipe
						v-if="small.length"
						class="swiper"
						:autoplay="0"
						:show-indicators="true"
						indicator-color="#7C8FFB"
						@change="swiperChange"
					>
						<van-swipe-item v-for="(item, i) in small" :key="i">
							<div class="swiper-item">
								<img :alt="getImageAlt(product)" :src="compPic(item)" @click="togglePopup('center', 'image', item)" />
							</div>
						</van-swipe-item>
					</van-swipe>
					<div v-else class="swiper">
						<div class="swiper-item">
							<img :alt="getImageAlt(product)" src="/staticSeo/images/placeholder.png" />
						</div>
					</div>
				</div>

				<div class="goodTitle textBox">
					<div style="padding-bottom: 0.5rem">
						<h1 class="title">{{ product.productName }}</h1>
						<div class="tag" v-if="product.tagList && product.tagList.some(item => [1, 2, 3, 5].includes(item))">
							<span class="tagtip_red" v-if="product.tagList ? product.tagList.indexOf(1) !== -1 : false">热销</span>
							<span class="tagtip_bluer" v-if="product.tagList ? product.tagList.indexOf(5) !== -1 : false">必备</span>
							<span class="tagtip_blue" v-if="product.tagList ? product.tagList.indexOf(3) !== -1 : false">临期</span>
							<span class="tagtip_green" v-if="product.tagList ? product.tagList.indexOf(2) !== -1 : false">精选</span>
						</div>
					</div>
					<div class="description" v-if="product.filialeCode === '00140'" v-ellipsis>{{ product.description }}</div>
					<div v-if="preferentialData.zero.purchaseZeroProductList && !!preferentialData.zero.purchaseZeroProductList.length">
						<span class="tag error-tag mr10">赠品</span>
						<div
							v-for="(zeroProduct, zIndex) in preferentialData.zero.purchaseZeroProductList"
							:key="'zeroProduct' + zIndex"
							class="font12 inline"
						>
							购买{{ zeroProduct.arriveNum }}{{ product.measuringUnit }}及以上立享赠品
							<div class="inline name-wrap" v-ellipsis @click="toProductDitall(zeroProduct)">
								{{ zeroProduct.productName }}
							</div>
							X{{ zeroProduct.giftQuantity }}
						</div>
					</div>
					<div class="line" style="display: flex; justify-content: space-between">
						<div style="flex: 1; display: flex">
							<span class="line_l" style="margin-right: 1rem">商家报价</span>
							<span class="line_r">
								<div v-if="isNaN(formatPrice(productShowPrice, 2, product.isControlSales, product.isSeeNoBuy))" class="price-name">
									{{ formatPrice(productShowPrice, 2, product.isControlSales, product.isSeeNoBuy) }}
								</div>
								<ShowAmount v-else :price="formatPrice(productShowPrice, 2, product.isControlSales, product.isSeeNoBuy)" />
							</span>
						</div>
						<div class="line_r" style="width: 8rem; display: flex; justify-content: flex-end">
							<i class="to_login" @click="goGuidePage" v-if="showCertification">去认证 ></i>
						</div>
					</div>
				</div>

				<!-- 优惠活动 -->
				<div class="goodActive textBox" v-if="isShowCoupon(preferentialData) || preferentialData.activity">
					<div>
						<p class="line"><span class="line_l text117">活动</span></p>
					</div>
					<div style="flex: 1">
						<p class="line" v-if="isShowCoupon(preferentialData)" @click="chooseCoupon">
							<span class="line_r">
								<i class="discount">优惠券</i>
								<i v-for="(item, index) in preferentialData.couponList" :key="'coupon' + index">
									<span v-if="index < 2" style="padding-right: 1rem">满{{ item.satisfyAmount }}减{{ item.couponAmount }}</span>
								</i>
							</span>
							<i class="iconfont icon-gongneng_xiangyou-37 line_goto"></i>
						</p>
						<p class="line" v-if="preferentialData.activity">
							<span class="line_r">
								<i class="discount">{{ formatActivityName(preferentialData.activity.activityType) }}</i>
								<i>{{ preferentialData.activity.desc }}</i>
							</span>
						</p>
					</div>
				</div>
			</div>

			<!-- 商品详情 -->
			<div class="goods-detail" id="md2">
				<div class="detail-item">
					<div style="display: flex" class="items-center">
						<i class="iconfont icon-v2zhandian-b"></i>
						<span class="label" style="width: 30px">站点</span>
					</div>
					<NuxtLink v-slot="{ href, navigate }" custom :to="siteHref">
						<a class="site-link" :href="href" @click="handleSiteEntryClick($event, navigate)">
							<span class="value" style="flex: 1">
								<ExpandableText customClass="mote-lines-value" :enableButton="false" :dt="product.filialeName" />
							</span>
							<i class="iconfont icon-maijia_youjin" style="font-size: 1rem !important; color: #c4c4c4"></i>
						</a>
					</NuxtLink>
				</div>
				<div class="detail-item2">
					<div style="flex: 1; display: flex">
						<i class="iconfont icon-guigexinghao"></i>
						<div class="label" style="width: 54px">规格型号</div>
						<div class="value" style="flex: 1">
							<ExpandableText customClass="mote-lines-value" :enableButton="false" :dt="product.specifications" />
							<b class="list" style="display: flex; align-items: center" v-if="stockNote">
								<i class="iconfont icon-checkbox" style="color: #e02020; font-size: 16px"></i>
								{{ stockNote }}
							</b>
							<span v-if="product.ippMiniPurchaseNum && product.ippPurchaseMultiple">
								起购数量：{{ product.ippMiniPurchaseNum }}；新增数量：{{ product.ippPurchaseMultiple }}；
							</span>
						</div>
					</div>
					<i class="iconfont icon-maijia_youjin" style="font-size: 1rem !important; color: #c4c4c4" @click="toggleBottomOpen('bottom')"></i>
				</div>
				<div class="detail-item">
					<div style="flex: 1; display: flex">
						<i class="iconfont icon-zhucerenbeianren"></i>
						<span class="label" style="width: 88px">注册人/备案人</span>
						<span class="value" style="flex: 1">
							<ExpandableText customClass="mote-lines-value" :enableButton="false" :dt="product.manufacturer" />
						</span>
					</div>
				</div>
				<div class="detail-item3">
					<div style="flex: 1; display: flex">
						<div><i class="iconfont icon-canshu"></i></div>
						<div class="label">参数</div>
						<div class="value">
							计量单位：{{ product.measuringUnit }}
							<br />
							商品性质：{{ product.productNatureStr }}
							<br />
							风险等级：{{ product.riskRankStr }}
							<br />
							新风险等级：{{ formatNewRisk(product.newRiskRank) }}
							<br />
							注册证号/备案凭证编号：{{ product.licenseCode }}
						</div>
					</div>
					<i class="iconfont icon-maijia_youjin" style="font-size: 1rem !important; color: #c4c4c4" @click="showAttrPopupFn"></i>
				</div>
			</div>

			<!-- 证照资料 -->
			<div class="content-license" id="md3">
				<div v-if="(picList && picList.length > 0) || (pdfList && pdfList.length > 0)" class="detail-title">证照资料</div>
				<div class="file-item" v-for="(item, i) in picList" :key="'pic' + i">
					<div class="file-box">
						<img class="thumbnail" src="/staticSeo/images/icon_image.svg" />
						<span v-ellipsis class="liText">{{ item.licenseFileName }}</span>
					</div>
					<i
						class="iconfont icon-maijia_youjin"
						style="font-size: 1rem !important; color: #c4c4c4"
						@click.stop="togglePopup1('center', 'image', item.ossPath)"
					></i>
				</div>
				<div class="file-item" v-for="(item, i) in pdfList" :key="'pdf' + i">
					<div class="file-box">
						<img class="thumbnail" src="/staticSeo/images/icon_pdf.svg" />
						<span v-ellipsis class="liText">{{ item.licenseFileName }}</span>
					</div>
					<i class="iconfont icon-maijia_youjin" style="font-size: 1rem !important; color: #c4c4c4" @click.stop="gotoLicence(item)"></i>
				</div>
			</div>

			<!-- 产品介绍：国械智造子站不展示；其余站点有详情图时展示 -->
			<div v-if="!isGxzz && imgList && imgList.length > 0" class="product-msg" id="md4">
				<div class="detail-title">产品介绍</div>
				<div class="detailBox">
					<img :alt="getImageAlt(product)" :src="compPic(item)" v-for="(item, index) in imgList" :key="item + index" />
				</div>
			</div>

			<!-- 购买须知 -->
			<div class="purchase-notice-box">
				<div class="detail-title">购买须知</div>
				<div class="purchase-notice">
					1.该产品可能含有禁忌内容或者注意事项，具体详情请咨询商家;
					<br />
					2.购买家用医疗器械，消费者应仔细阅读产品说明书或者在医务人员的指导下购买和使用。
					<br />
					3.如您想了解"可询价"商品的更多价格信息，可在"个人中心"-"询价/投诉建议"版块留言咨询，并留下联系方式，后台将有工作人员与您联系。
				</div>
			</div>

			<!-- 国械智造：商品信息（SSR 经 /api/goodDetail/full 聚合的 productAttrSnap） -->
			<div v-if="isGxzz && gxzzHasProductInfoBlocks" class="gxzz-product-info" id="md5">
				<div class="detail-title">商品信息</div>
				<div class="gxzz-pi-inner">
					<div v-if="gxzzProductAttrSnap.paramGroups.length" class="gxzz-pi-block">
						<div class="gxzz-pi-section-head">商品参数</div>
						<div v-for="paramGroup in gxzzProductAttrSnap.paramGroups" :key="paramGroup.title" class="gxzz-pi-group">
							<div v-if="paramGroup.displaySign === 1" class="gxzz-pi-subhead">
								<i v-if="paramGroup.iconClass" :class="['iconfont', paramGroup.iconClass]"></i>
								<span>{{ paramGroup.title }}</span>
							</div>
							<div v-for="attrRow in paramGroup.rows" :key="paramGroup.title + '-' + attrRow.label" class="gxzz-pi-row">
								<span class="gxzz-pi-label">{{ attrRow.label }}</span>
								<span class="gxzz-pi-value">{{ attrRow.value }}</span>
							</div>
						</div>
					</div>
					<div v-if="gxzzProductAttrSnap.packageHtmlSections.length" class="gxzz-pi-block">
						<div class="gxzz-pi-section-head">商品清单</div>
						<div
							v-for="(htmlBlock, sectionIndex) in gxzzProductAttrSnap.packageHtmlSections"
							:key="'pkg-' + sectionIndex"
							class="gxzz-pi-package-wrap"
						>
							<div v-if="htmlBlock.title" class="gxzz-pi-package-title">{{ htmlBlock.title }}</div>
							<!-- 接口富文本，与 PC 同源由后端产出 -->
							<div class="gxzz-pi-html gxzz-pi-paragraph" v-html="htmlBlock.contentHtml"></div>
						</div>
					</div>
					<div v-if="gxzzProductAttrSnap.afterSalesLines.length" class="gxzz-pi-block">
						<div class="gxzz-pi-section-head">售后服务</div>
						<p
							v-for="(afterSalesLine, lineIndex) in gxzzProductAttrSnap.afterSalesLines"
							:key="'as-' + lineIndex"
							class="gxzz-pi-paragraph"
						>
							{{ afterSalesLine }}
						</p>
					</div>
				</div>
			</div>
			<!-- SEO 差异化内容（隐藏但对搜索引擎可见） -->
			<div class="seo-footer-content">本商品由【{{ companyFullName }}】提供销售及售后服务 服务范围：{{ provinceText }}</div>
		</div>

		<!-- 底部商品导航 -->
		<div v-show="showBottomNav && !showCustomLoading" class="goods-nav-bar">
			<div class="nav-options">
				<div class="nav-option-item" @click="onClick({ content: { text: '店铺' } })">
					<i class="iconfont icon-zhandian" style="font-size: 1.78rem !important"></i>
					<span>店铺</span>
				</div>
				<div class="nav-option-item" @click="isFollow ? onClick({ content: { text: '已收藏' } }) : onClick({ content: { text: '收藏' } })">
					<i
						:class="['iconfont', isFollow ? 'icon-v2_shoucang-a' : 'icon-v2_shoucang-b']"
						:style="{ color: isFollow ? '#455BD9' : '#595959', fontSize: '1.78rem !important' }"
					></i>
					<span>{{ isFollow ? '已收藏' : '收藏' }}</span>
				</div>
				<div class="nav-option-item" @click="onClick({ content: { text: '常购清单' } })">
					<i class="iconfont icon-v2_changgouqingdan" style="font-size: 1.78rem !important"></i>
					<span>常购清单</span>
				</div>
			</div>
			<div class="nav-buttons">
				<template v-if="isConsultMode">
					<button class="nav-btn btn-consult" @click="buttonClick({ content: { text: '我要咨询' } })">我要咨询</button>
				</template>
				<template v-else>
					<button class="nav-btn btn-cart" @click="buttonClick({ content: { text: '加入购物车' } })">加入购物车</button>
					<button class="nav-btn btn-buy" @click="buttonClick({ content: { text: '立即购买' } })">立即购买</button>
				</template>
			</div>
		</div>

		<!-- 规格型号底部弹窗 -->
		<!-- eslint-disable-next-line vue/no-v-model-argument -->
		<van-popup v-model:show="specsPopupShow" position="bottom" :round="true">
			<div class="specifications-content">
				<div class="popup-header">
					<span class="title">规格型号设置</span>
					<i class="iconfont icon-guanbi" style="color: #c4c6c9; font-size: 1.5rem; cursor: pointer" @click="toggleBottomClose"></i>
				</div>
				<div class="specifications-box">
					<div class="product-box">
						<img
							:alt="getImageAlt(product)"
							class="img"
							:src="product.defaultImageUrl || small[0] || '/staticSeo/images/placeholder.png'"
							style="width: 6.67rem; height: 6.67rem; object-fit: contain"
						/>
						<div class="product-info">
							<div class="title">{{ product.productName }}</div>
							<div class="specifications" style="margin-top: 4px">{{ product.specifications }}</div>
							<div class="specifications">{{ product.manufacturer }}</div>
							<div v-if="isNaN(formatPrice(productShowPrice, 2, product.isControlSales, product.isSeeNoBuy))">
								{{ formatPrice(productShowPrice, 2, product.isControlSales, product.isSeeNoBuy) }}
							</div>
							<ShowAmount v-else :price="formatPrice(productShowPrice, 2, product.isControlSales, product.isSeeNoBuy)" />
						</div>
					</div>
					<div class="quotation-area" v-if="loginType == 4 && districtList.length > 1 && districtList[0] && districtList[0].areaName">
						<div class="quotation-title">报价区域</div>
						<div class="area-box">
							<div
								@click="isSelected(index)"
								class="checkRadio"
								:class="active === index ? 'checked' : ''"
								v-for="(item, index) of districtList"
								:key="'district' + index"
							>
								<span>{{ item.areaName }}</span>
							</div>
						</div>
					</div>
					<div class="quantity-rule">
						<div class="quotation-num" v-if="product.ippStatus == 101 && product.ippMiniPurchaseNum">
							<span>数量规则</span>
							<span class="num-title">起购数量{{ product.ippMiniPurchaseNum }}，按{{ product.ippPurchaseMultiple }}倍数量新增</span>
						</div>
						<div class="select-num">
							<van-stepper
								class="step-number"
								v-model="productNum"
								:step="product.ippPurchaseMultiple && product.ippStatus === 101 ? product.ippPurchaseMultiple : 1"
								:min="product.ippMiniPurchaseNum && product.ippStatus === 101 ? product.ippMiniPurchaseNum : 1"
								@change="changeVal(product)"
							/>
						</div>
					</div>
				</div>
			</div>
		</van-popup>

		<!-- 商品属性弹窗 -->
		<ProductAttrPopup ref="attrPopupRef" :product="product" @close="onAttrClose" />

		<!-- 优惠券弹窗 -->
		<CouponPopup
			ref="chooseCouponRef"
			:preferentialData="preferentialData"
			@change="val => (popOpen = val)"
			@queryList="getDiscountByProductId"
			:indexs="indexs"
		/>
		<ClientOnly>
			<GoTop :scrollTop="scrollTop" :scrollContainer="scrollRef" />
		</ClientOnly>

		<!-- 意向客户弹窗 + 客服 -->
		<CollectionIntention :product="product" :showPopup="showPopup" :trackingChannel="gxzzProductEntryChannel" @close="handleConsultClose" />

		<!-- 自定义 loading 遮罩 -->
		<div v-if="showCustomLoading" class="custom-loading-mask">
			<div class="loading-content">
				<div class="loading-spinner"></div>
				<span class="loading-text">加载中...</span>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, nextTick, onBeforeUnmount, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { showToast as vantShowToast, showImagePreview, Notify } from 'vant';
import _ from 'lodash-es';
import {
	getDiscountByProductId as getDiscountApi,
	addCart as addCartApi,
	productExpireDate as productExpireDateApi,
	isSell,
	addFavoriteList,
	removeFavorite,
	browseHistoryAdd,
} from '@/api/goods.js';
import { getUserSite, getWebsiteInfoNoLogin } from '@/api/index';
import { getShoppingCartActivity } from '@/api/buyCar.js';
import { getCompanyInfo, setVisitInfo, setBehaviorInfo } from '@/common/common.js';
import CouponPopup from '@/pages/goodDetail/components/coupon.vue';
import { compressPic } from '@/utils/utils';
import { mobileProductDetailPath, normalizeProductIdParam } from '@/utils/link/mobileProductDetail';
import { NEW_RISK_ENUM } from '@/enum-js/prodcut';
import CollectionIntention from '@/components/collectionIntention/index.vue';
import ExpandableText from '@/components/ExpandableText.vue';
import { checkMerchantStatus } from '@/utils/checkMerchantStatus';
import ProductAttrPopup from '@/pages/goodDetail/ProductAttrPopup.vue';
import { useCartStore } from '@/stores/cart';
import { getStorageSync, setStorageSync } from '@/utils/storage.js';
import { useAnalytics } from '@/composables/useAnalytics';
import {
	buildGxzzProductTrackingTargetId,
	consumeGxzzTrackingContext,
	GXZZ_TRACKING_CHANNEL,
	GXZZ_TRACKING_TARGET,
	setGxzzTrackingContext,
} from '@/utils/gxzzTracking';

import { getPrice, getProductPriceType, getReferencePrice, isCooperationPrice } from '@/utils/productPrice';

const route = useRoute();
const cartStore = useCartStore();
const { formatPrice } = usePriceFormat();
const { trackEvent } = useAnalytics();
const config = useRuntimeConfig();
const pcBase = (config.public.publicPcUrl || '').replace(/\/$/, '');

/** 国械「商品信息」区块：与 SSR `/api/goodDetail/full` 返回的 `productAttrSnap` 对齐 */
const gxzzProductAttrSnap = ref({
	paramGroups: [],
	packageHtmlSections: [],
	afterSalesLines: [],
});

/**
 * 将接口 `getProductInfo` 的 data 规范为模板可用结构（兼容 packageText 为数组或旧版字符串）
 * @param {unknown} snapshot
 */
function normalizeGxzzProductAttrSnap(snapshot) {
	if (!snapshot || typeof snapshot !== 'object') {
		return { paramGroups: [], packageHtmlSections: [], afterSalesLines: [] };
	}
	const paramGroupsRaw = Array.isArray(snapshot.paramGroups) ? snapshot.paramGroups : [];
	const paramGroups = paramGroupsRaw
		.filter(group => group && typeof group === 'object')
		.map(group => ({
			title: String(group.title ?? ''),
			iconClass: String(group.iconClass ?? ''),
			displaySign: group.displaySign != null && Number(group.displaySign) === 0 ? 0 : 1,
			rows: Array.isArray(group.rows) ? group.rows : [],
		}));
	const packageRaw = snapshot.packageText;
	let packageHtmlSections = [];
	if (Array.isArray(packageRaw)) {
		packageHtmlSections = packageRaw
			.filter(block => block && typeof block === 'object')
			.map(block => ({
				title: String(block.title ?? ''),
				contentHtml: String(block.content ?? ''),
			}));
	} else if (typeof packageRaw === 'string' && packageRaw.trim()) {
		packageHtmlSections = [{ title: '', contentHtml: packageRaw }];
	}
	const afterSalesRaw = snapshot.afterSales;
	const afterSalesLines = Array.isArray(afterSalesRaw)
		? afterSalesRaw.map(line => String(line))
		: typeof afterSalesRaw === 'string' && afterSalesRaw.trim()
			? [afterSalesRaw]
			: [];
	return { paramGroups, packageHtmlSections, afterSalesLines };
}
const rawRouteProductId = String(route.params?.productId ?? '');
const routeCompanyId = String(route.params?.companyId ?? '');
const normalizedRouteProductId = normalizeProductIdParam(rawRouteProductId);

// 无 .html 后缀的旧链接 301 到 /{companyId}/products/{productId}.html
if (rawRouteProductId && routeCompanyId && !/\.html$/i.test(rawRouteProductId)) {
	const canonicalPath = mobileProductDetailPath(routeCompanyId, normalizedRouteProductId);
	if (canonicalPath) {
		await navigateTo(canonicalPath, { redirectCode: 301, replace: true });
	}
}

useHead(() => {
	const cid = route.params?.companyId;
	const pid = normalizeProductIdParam(route.params?.productId);
	const href = pcBase && pid && cid ? `${pcBase}/${cid}/products/${pid}.html` : null;
	return {
		link: href ? [{ rel: 'canonical', href }] : [],
	};
});

// ——— Reactive State ———
const showCustomLoading = ref(true);
const showBottomNav = ref(true);
const hideTab = ref(true);
const investmentRank = ref(1);
const indexs = ref(0);
const show = ref(false);
const current = ref(0);
const productNum = ref(1);
const isLogin = ref(false);
const companyId = ref(null);
const productId = ref(null);
const companyCode = ref(null);
const selectedData1 = ref([]);
const product = ref({});
const districtList = ref([]);
const isSeeNoBuy = ref(0);
const isHaveEmptyPrice = ref(false);
const emptyPriceIndex = ref(null);
const active = ref(null);
const productPrice = ref(null);
const agreementPriceId = ref(null);
const pdfList = ref([]);
const picList = ref([]);
const small = ref([]);
const priceShowType = ref(0);
const productShowPrice = ref('');
const stockNote = ref('');
const preferentialData = ref({ couponList: [], zero: {} });
const expireDate = ref('');
const buyNow = ref(false);
const scrollTop = ref(0);
const isRFQ = ref(true);
const favoriteList = ref([]);
const toView = ref('');
const popOpen = ref(false);
/** 与顶部 Tab 顺序对齐的各锚点滚动偏移（offsetTop - 顶栏高度） */
const sectionStarts = ref([]);
const flags = ref(false);
const isAutoScrolling = ref(false);
let scrollTimer = null;
const cartAddFlag = ref(false);
const showPdf = ref(false);
const isPurchase = ref(false);
const notLoginNotRFQ = ref(false);
const isFollow = ref(false);
const licenseCode = ref('');
const showPopup = ref(false);
/** 商品详情从国械智造专区进入时的渠道，供详情进入及咨询弹窗曝光上报。 */
const gxzzProductEntryChannel = ref('');
const loginType = ref(1);
const specsPopupShow = ref(false);
/** SSR 下发的 websiteData，供 onMounted 同步 loginType 到 localStorage */
const ssrWebsiteDataRef = ref(null);
/** SSR 下发的当前站点 companyCode，供 onMounted 调用 getUserSite 使用 */
const ssrCompanyCodeRef = ref(null);

// DOM refs
const scrollRef = ref(null);
const navBarRef = ref(null);
const attrPopupRef = ref(null);
const chooseCouponRef = ref(null);

// ——— Computed ———
const imgList = computed(() => {
	if (product.value.detailImageUrls?.length) {
		return product.value.detailImageUrls;
	}
	return small.value;
});

/** 合作价按普通可售商品：底部展示加购/立购，不要「我要咨询」 */
const isConsultMode = computed(() => {
	const productPrice = product.value.productPrice ?? productShowPrice.value;
	// 国械智造未登录用户也可直接提交咨询；可询价或 0 元商品同样固定展示咨询入口。
	if (isGxzz.value && (!isLogin.value || productPrice === '可询价' || productPrice === 0 || productPrice === '0')) return true;
	if (isCooperationPrice(product.value)) return false;
	return isNaN(formatPrice(productShowPrice.value, 2, product.value.isControlSales, product.value.isSeeNoBuy));
});
const siteHref = computed(() => `/${companyId.value || route.params.companyId || ''}`);

const showCertification = computed(() => {
	if (!import.meta.client) return false;
	const info = getStorageSync('userInfo') || {};
	return [0, 1, 2, 4].includes(info?.merchantStatus);
});

const isGxzz = useIsGxzzSite(computed(() => route.params.companyId));

let gxzzProductEnterTracked = false;

/** 消费国械智造商品来源并上报商品详情进入事件。 */
function trackGxzzProductPageEnter() {
	if (!import.meta.client || gxzzProductEnterTracked) return;

	const currentCompanyCode = ssrCompanyCodeRef.value;
	const currentCompanyName = product.value.websiteName || product.value.companyName;
	const currentProductCode = product.value.productCode;
	const currentProductName = product.value.productName;
	if (!currentCompanyCode || !currentCompanyName || !currentProductCode || !currentProductName) return;

	const trackingTargetId = buildGxzzProductTrackingTargetId(companyId.value, productId.value);
	gxzzProductEntryChannel.value = consumeGxzzTrackingContext(GXZZ_TRACKING_TARGET.PRODUCT, trackingTargetId);
	if (![GXZZ_TRACKING_CHANNEL.SPECIAL_PRODUCT_CARD, GXZZ_TRACKING_CHANNEL.SUBSITE_SEARCH_RESULT].includes(gxzzProductEntryChannel.value)) {
		return;
	}
	// 保留当前商品来源，页面刷新后仍能重新上报进入埋点。
	setGxzzTrackingContext(GXZZ_TRACKING_TARGET.PRODUCT, trackingTargetId, gxzzProductEntryChannel.value);

	gxzzProductEnterTracked = true;
	trackEvent({
		companyCode: currentCompanyCode,
		companyName: currentCompanyName,
		module: '商品详情页',
		eventCode: 'product_page_enter',
		eventName: '进入商品详情页',
		attrName: 'channel_type',
		attrCode: gxzzProductEntryChannel.value,
		ext1: currentProductCode,
		ext2: currentProductName,
	});
}

watch([isGxzz, () => product.value.productCode], () => {
	trackGxzzProductPageEnter();
});

/** 国械商品信息接口是否有任一可展示块（用于 Tab 与 md5 区块显隐） */
const gxzzHasProductInfoBlocks = computed(() => {
	const snapshot = gxzzProductAttrSnap.value;
	return snapshot.paramGroups.length > 0 || snapshot.packageHtmlSections.length > 0 || snapshot.afterSalesLines.length > 0;
});

const controlItems = computed(() => {
	const items = ['商品'];
	if ((picList.value && picList.value.length > 0) || (pdfList.value && pdfList.value.length > 0)) {
		items.push('证照');
	}
	if (!isGxzz.value && imgList.value && imgList.value.length > 0) {
		items.push('产品介绍');
	}
	if (isGxzz.value && gxzzHasProductInfoBlocks.value) {
		items.push('商品信息');
	}
	return items;
});

// ——— Watch ———
watch(toView, val => {
	if (!val) return;
	nextTick(() => {
		const el = document.getElementById(val);
		if (el && scrollRef.value) {
			isAutoScrolling.value = true;
			clearTimeout(scrollTimer);
			scrollRef.value.scrollTo({ top: el.offsetTop, behavior: 'smooth' });
			scrollTimer = setTimeout(() => {
				isAutoScrolling.value = false;
			}, 600);
		}
		toView.value = '';
	});
});

watch(
	() => [isGxzz.value, gxzzHasProductInfoBlocks.value, picList.value?.length, pdfList.value?.length, imgList.value?.length],
	() => nextTick(() => calculateScrollOffsets()),
	{ flush: 'post' }
);

// ——— Helpers ———
/** 图片 URL 压缩（缩略图质量 50） */
const compPic = url => compressPic(url || '', 50);

// ——— Methods ———
/** 合作价页面上展示「合作价」文案，加购/活动入参与列表一致用 getPrice */
function priceForCartApi() {
	return isCooperationPrice(product.value) ? getPrice(product.value) : productShowPrice.value;
}

/** 登录用户：添加当前商品到浏览历史 */
async function handleBrowseHistoryAdd() {
	try {
		const user = getStorageSync('user') || {};
		await browseHistoryAdd({ userId: user.userId, productId: productId.value });
	} catch (error) {
		console.error('添加浏览历史失败:', error);
	}
}

/** 打开商品参数弹窗，并隐藏底部导航 */
function showAttrPopupFn() {
	showBottomNav.value = false;
	attrPopupRef.value?.open();
}

/** 关闭参数弹窗后恢复底部导航显示 */
function onAttrClose() {
	showBottomNav.value = true;
}

/** 将新风险等级枚举转为展示文案 */
function formatNewRisk(val) {
	return NEW_RISK_ENUM[val] || val;
}

/** 跳转到认证引导页（去认证） */
function goGuidePage() {
	navigateTo('/login/guidePage');
}

/** 点击商品详情站点入口：记录来源，进入子站首页后统一上报 gxzz_subsites_homepage_enter。 */
function handleSiteEntryClick(event, navigate) {
	if (isGxzz.value) {
		setGxzzTrackingContext(GXZZ_TRACKING_TARGET.SUBSITE, companyId.value || route.params.companyId, GXZZ_TRACKING_CHANNEL.PRODUCT_DETAIL_STORE);
	}
	navigate(event);
}

/** 主区域滚动：同步顶部 Tab 高亮、控制导航栏显隐 */
function scrollChange(e) {
	const st = e.target.scrollTop;
	scrollTop.value = st;
	const shouldHide = st <= 10;
	if (hideTab.value !== shouldHide) {
		hideTab.value = shouldHide;
	}
	if (!flags.value && !isAutoScrolling.value) {
		const starts = sectionStarts.value;
		if (!starts.length) return;
		if (starts.length === 1) {
			current.value = 0;
			return;
		}
		if (st < starts[1]) {
			current.value = 0;
		} else if (starts.length === 2) {
			current.value = 1;
		} else {
			let found = false;
			for (let i = 1; i < starts.length - 1; i++) {
				if (st >= starts[i] && st < starts[i + 1]) {
					current.value = i;
					found = true;
					break;
				}
			}
			if (!found) current.value = starts.length - 1;
		}
	}
}

/** 顶部 Tab 文案 → 页面锚点 id（与 `controlItems` 顺序一致） */
function controlTabToAnchorId(label) {
	const map = { 商品: 'md1', 证照: 'md3', 产品介绍: 'md4', 商品信息: 'md5' };
	return map[label] || 'md1';
}

/** 点击顶部 Tab（商品/证照/产品介绍/商品信息 等）：切换当前项并滚动到对应锚点 */
function onClickItem(e) {
	flags.value = e.currentIndex === 3;
	if (current.value !== e.currentIndex) {
		current.value = e.currentIndex;
		const lab = controlItems.value[e.currentIndex];
		toView.value = controlTabToAnchorId(lab);
	}
}

/** 点击页面空白处关闭「更多」下拉 */
function clooseBtn() {
	show.value = false;
}

/** 点击右上角更多图标，展开/收起操作菜单 */
function dropDown() {
	show.value = !show.value;
}

/** 返回上一页 */
function goBack() {
	setTimeout(() => {
		history.go(-1);
	}, 100);
}

/** 底部主按钮点击：我要咨询 / 加入购物车 / 立即购买 */
function buttonClick(e) {
	if (e.content.text === '我要咨询' && (isGxzz.value || gxzzProductEntryChannel.value)) {
		trackEvent({
			module: '商品详情页',
			eventCode: 'product_page_click',
			eventName: '商品详情页点击',
			attrName: 'button_name',
			attrCode: e.content.text,
			ext1: product.value.productCode,
			ext2: product.value.productName,
		});
	}

	if (e.content.text === '我要咨询' && isGxzz.value) {
		showBottomNav.value = false;
		showPopup.value = true;
		return;
	}

	const hasAccessToken = import.meta.client ? !!getStorageSync('cmdc_access_token_mobile') : !!isLogin.value;
	if (!hasAccessToken) {
		window.location.href = '/login';
		return;
	}

	if (e.content.text === '我要咨询') {
		showBottomNav.value = false;
		showPopup.value = true;
		return;
	}
	if (investmentRank.value != 0) return;
	const needJump = checkMerchantStatus();
	if (needJump) return;
	if (isRFQ.value) return;
	if (e.content.text === '加入购物车') {
		buyNow.value = true;
		cartAddFlag.value = true;
		addCart(productId.value, priceForCartApi(), product.value.tag);
	} else if (e.content.text === '立即购买') {
		buyNow.value = true;
		cartAddFlag.value = false;
		addOrder(product.value, priceShowType.value != 2 || !isLogin.value || isRFQ.value);
	}
}

function handleConsultClose() {
	showPopup.value = false;
	showBottomNav.value = true;
}

/** 底部导航点击：店铺 / 收藏 / 已收藏 / 常购清单（进店铺只跳转，不做商户认证校验） */
function onClick(e) {
	if (e.content.text === '收藏' && isGxzz.value) {
		trackEvent({
			module: '商品详情页',
			eventCode: 'product_page_click',
			eventName: '商品详情页点击',
			attrName: 'button_name',
			attrCode: '关注',
			ext1: product.value.productCode,
			ext2: product.value.productName,
		});
	}

	switch (e.content.text) {
		case '店铺':
			if (isGxzz.value) {
				setGxzzTrackingContext(
					GXZZ_TRACKING_TARGET.SUBSITE,
					companyId.value,
					GXZZ_TRACKING_CHANNEL.PRODUCT_DETAIL_STORE
				);
			}
			window.location.href = `/${companyId.value}`;
			break;
		case '收藏':
			if (checkMerchantStatus()) return;
			handleFollow(productId.value);
			break;
		case '已收藏':
			if (checkMerchantStatus()) return;
			handleNotFollow(productId.value);
			break;
		case '常购清单':
			if (checkMerchantStatus()) return;
			window.location.href = '/pages/frequentlyPurchasedProduct/frequentlyPurchasedProduct';
			break;
	}
}

/** 加入购物车：登录则请求接口并埋点，未登录跳转登录页 */
async function addCart(id, price, tag) {
	if (tag) return;
	if (isLogin.value) {
		let agreeId = agreementPriceId.value && loginType.value == 4 ? agreementPriceId.value : 0;
		if (product.value.agreementPrices && product.value.agreementPrices.length === 1) {
			agreeId = product.value.agreementPrices[0].agreementPriceId;
		}
		const params = {
			currentCompanyId: companyId.value,
			productId: id,
			quantity: productNum.value,
			agreementPriceId: agreeId,
			price,
			filialeCode: product.value.filialeCode,
		};
		await getCompanyInfo(product.value.filialeCode);
		addCartApi(params).then(res => {
			if (res.code == 200) {
				vantShowToast({ message: '加入购物车成功', position: 'bottom' });
				Notify({ type: 'success', message: '您可以在我的服务【常购清单】中查看明细', duration: 3000 });
				const user = getStorageSync('user') || {};
				setBehaviorInfo({
					module: '加入购物车',
					customerCompanyName: user.customerCompanyName,
					busiType: '11',
					sellerCompanyCode: product.value.filialeCode,
					sellerCompanyName: product.value.filialeName,
					productCode: product.value.productCode,
					productName: product.value.productName,
					isMove: 1,
				});
				cartStore.updateCartCount();
			} else if (res.code === '1076') {
				vantShowToast({ message: res.message, position: 'bottom' });
			} else {
				vantShowToast({ message: res.message || '加入购物车失败', position: 'bottom' });
				return;
			}
			specsPopupShow.value = false;
		});
	} else {
		window.location.href = '/login';
	}
}

/** 格式化当前商品为订单项（含活动/优惠券），并写入 localStorage 供订单页使用 */
async function formatProduct(val) {
	await getShoppingCartActivityFn(val);
	const params = {
		buyerCartId: '',
		agreementPriceId: val.agreementPriceId,
		auxiliaryMeasuringUnit: val.auxiliaryMeasuringUnit,
		firstPrice: productPrice.value,
		imageUrl: val.defaultImageUrl,
		manufacturer: val.manufacturer,
		materialCode: val.materialCode,
		measuringUnit: val.measuringUnit,
		optionStr: val.specifications,
		price: productPrice.value == 0 || productPrice.value ? productPrice.value : getReferencePrice(val),
		pricingMeasuringUnit: val.pricingMeasuringUnit,
		procurementMeasuringUnit: val.procurementMeasuringUnit,
		productCode: val.productCode,
		productId: val.productId,
		productName: val.productName,
		productLineCode: val.lineCode,
		productLineName: val.lineName,
		description: val.description,
		quantity: productNum.value,
		referencePrice: getReferencePrice(val),
		status: val.status,
		storageType: val.storageCondition,
		subtotal: (productPrice.value * productNum.value).toFixed(2),
		riskRank: val.riskRank,
		productClassify: val.productClassify,
		productNature: val.productNature,
		filialeCode: val.filialeCode,
		companyId: companyId.value,
		specifications: val.specifications,
		activityAmount: val.activityAmount,
		couponAmount: val.couponAmount,
		areaName: getCurrentAreaName(),
	};
	localStorage.setItem('orderList', JSON.stringify([params]));
}

/** 获取购物车活动与可用优惠券，回写到商品项并写入 userReceiveId 等 */
async function getShoppingCartActivityFn(item) {
	const checkList = [
		{
			productId: item.productId,
			productCode: item.productCode,
			productPrice: priceForCartApi(),
			purchaseQuantity: productNum.value,
			agreementPriceId: districtList.value[active.value] ? districtList.value[active.value].agreementPriceId : null,
			imageUrl: item.imageUrl,
			checked: false,
			activityUseSgin: 1,
		},
	];
	const couponsList = await getShoppingCartActivity({
		companyCode: item.filialeCode,
		couponUseSgin: 1,
		orderProductList: checkList,
	});
	if (couponsList.success) {
		if (couponsList.data.couponActivityVo.length) {
			item['couponActivityVo'] = couponsList.data.couponActivityVo;
			const couponList = couponsList.data.couponActivityVo.filter(i => i.chooseSgin === 1);
			if (couponList.length === 1) {
				setStorageSync('userReceiveId', couponList[0].userReceiveId);
				setStorageSync('userReceiveId2', '');
			} else if (couponList.length >= 2) {
				setStorageSync('userReceiveId', couponList[0].userReceiveId);
				setStorageSync('userReceiveId2', couponList[1].userReceiveId);
			}
		} else {
			item['showActivity'] = '';
			item['chooseUserReceiveId'] = '';
			item['couponAmount'] = 0;
			item.chooseCouponType = 0;
			item['chooseUserReceiveId2'] = '';
		}
		if (couponsList.data.orderProductList.length) {
			couponsList.data.orderProductList.forEach(item2 => {
				if (item.productId === item2.productId && priceForCartApi() === item2.productPrice) {
					for (const p in item2) {
						item[p] = item2[p];
					}
				}
			});
		}
	}
}

/** 立即购买：校验登录与可售后格式化订单并跳转订单页；若为加购再购则先加购 */
function addOrder(prod, tag) {
	setTimeout(() => {
		if (tag) return;
		if (!getStorageSync('cmdc_access_token_mobile')) {
			vantShowToast({ message: '抱歉，请先登录！', position: 'bottom' });
			setTimeout(() => {
				window.location.href = '/login';
			}, 1000);
			return;
		}
		if (cartAddFlag.value) {
			addCart(product.value.productId, priceForCartApi());
		} else {
			isSell({ companyCode: prod.filialeCode, companyId: companyId.value, list: [prod] }).then(res => {
				if (res.code === 'fail') {
					vantShowToast({ message: res.data.errorMessage, position: 'bottom' });
				} else {
					formatProduct(prod).then(() => {
						// orderOrigin：1立即购买-PC端 2购物车-PC端 3常购清单-PC端 4再来一单-PC端 5快速下单-PC端
						// 6快捷下单-PC端 7立即购买-移动端 8购物车-移动端 9代客下单-后台 10代客下单-移动端
						window.location.href = '/pages/buyCar/order/order?orderOrigin=7';
					});
				}
			});
		}
		specsPopupShow.value = false;
	}, 500);
}

/** 选择某一档区域价格，更新当前价格与协议价并刷新展示价 */
function isSelected(param) {
	if (active.value == param) {
		if (isHaveEmptyPrice.value) {
			active.value = emptyPriceIndex.value;
			productPrice.value = districtList.value[emptyPriceIndex.value].price;
			agreementPriceId.value = districtList.value[emptyPriceIndex.value].agreementPriceId;
			setProductShowPrice();
			return;
		}
	}
	active.value = param;
	districtList.value.forEach((item, index) => {
		if (param == index) {
			productPrice.value = item.price;
			agreementPriceId.value = item.agreementPriceId;
			setProductShowPrice();
		}
	});
}

/** 活动类型枚举转展示名称：特价/折扣/单品促销 */
function formatActivityName(val) {
	switch (val) {
		case 1:
			return '特价';
		case 2:
			return '折扣';
		case 3:
			return '单品促销';
		default:
			return '';
	}
}

/** 请求商品优惠信息（优惠券、零元购等）并写入 preferentialData */
async function getDiscountByProductId() {
	const res = await getDiscountApi({
		productId: productId.value,
		companyCode: product.value.filialeCode,
		productCode: product.value.productCode,
	});
	if (res.success) {
		res.data.couponList.forEach(item => {
			item.disabled = false;
		});
		preferentialData.value = res.data;
	}
}

// ——— 商品数据处理：抽离公共方法 ———

/** 处理区域价格列表，选中默认价格项（优先无区域名称 → 最低价）；无协议列表时按 PC handleProductInfo 用 referencePrice 等补全 productPrice */
function resolveDistrictPrices(agreementPrices, result) {
	isHaveEmptyPrice.value = false;
	let foundEmpty = false;

	districtList.value = (agreementPrices || []).map((item, index) => {
		if (!item.areaName) {
			if (!foundEmpty) {
				isHaveEmptyPrice.value = true;
				emptyPriceIndex.value = index;
				foundEmpty = true;
			}
			return { ...item, areaName: '报价', _isEmptyAreaName: true };
		}
		return item;
	});

	if (isHaveEmptyPrice.value) {
		active.value = emptyPriceIndex.value;
		productPrice.value = districtList.value[emptyPriceIndex.value].price;
		agreementPriceId.value = districtList.value[emptyPriceIndex.value].agreementPriceId;
	} else if (districtList.value.length) {
		const minPrice = Math.min(...districtList.value.map(o => o.price));
		districtList.value.forEach((item, index) => {
			if (item.price === minPrice) {
				active.value = index;
				productPrice.value = item.price;
				agreementPriceId.value = item.agreementPriceId;
			}
		});
	} else if (result) {
		const raw = result.productPrice ?? result.price;
		const ref = getReferencePrice(result);
		const merged = raw || (raw == 0 ? raw : ref);
		if (merged === null || merged === undefined || merged === '') {
			productPrice.value = null;
		} else if (typeof merged === 'string' && merged !== '0' && Number.isNaN(Number(merged))) {
			productPrice.value = merged;
		} else {
			const n = Number(merged);
			productPrice.value = Number.isNaN(n) ? null : n;
		}
	}
}

/** 获取当前选中区域的 areaName：标记项（原始为空）返回空字符串，其他返回原值 */
function getCurrentAreaName() {
	const item = districtList.value[active.value];
	if (!item) return '';
	return item._isEmptyAreaName ? '' : item.areaName || '';
}

/** 解析证照资质信息，将附件分类为图片和 PDF */
function resolveLicenseInfo(licenseInfos) {
	picList.value = [];
	pdfList.value = [];
	if (!licenseInfos?.length) return;

	const grouped = _.groupBy(licenseInfos, 'licenseType');
	if (grouped['001']?.length > 0) {
		licenseCode.value = [...new Set(grouped['001'].map(i => i.licenseCode))].join('/');
	} else if (grouped['002']?.length > 0) {
		licenseCode.value = [...new Set(grouped['002'].map(i => i.licenseCode))].join('/');
	} else {
		licenseCode.value = licenseInfos[0].licenseCode;
	}

	licenseInfos.forEach(item => {
		item.licenseFiles?.forEach(file => {
			if (file.ossPath) {
				if (isImageFile(file.ossPath)) picList.value.push(file);
				if (isPdfFile(file.ossPath)) pdfList.value.push(file);
			}
		});
	});
}

const getImageAlt = item => {
	const brand = item.seoBrand || item.brandName || '';
	const productName = item.productName || item.productname || '';
	const spec = item.specifications || item.optionStr || '';

	// alt={品牌} {商品标题} {规格}
	const parts = [brand, productName, spec].filter(Boolean);
	return parts.join(' ') || '商品图片';
};

/**
 * 根据登录类型、合作价、isSeeNoBuy、控销与参考价确定「展示价 / 是否询价」。
 * 控销（isControlSales===1）：isSeeNoBuy===0 白名单展示数字价；isSeeNoBuy===1 时依 isSee——isSee===1 可见不可买展示「可询价」，isSee===0 由后端过滤不展示商品。展示价与模板中 `formatPrice(价, 2, isControlSales, isSeeNoBuy)`（`usePriceFormat` → `priceFormat`）一致；**不修改接口下发的 `isSee`**。
 */
function applyPriceDisplayRules(resultData) {
	if (loginType.value == 1 && isSeeNoBuy.value == 666) {
		priceShowType.value = 0;
		productShowPrice.value = '可询价';
		isRFQ.value = true;
		notLoginNotRFQ.value = true;
	} else if (isLogin.value && Number(getProductPriceType(resultData)) === 1 && (productPrice.value === 0 || productPrice.value === '0')) {
		// 与 PC showPrice 一致：合作价优先于 isSeeNoBuy==1；底部按普通商品展示加购/立购（非询价）
		priceShowType.value = 2;
		productShowPrice.value = '合作价';
		isRFQ.value = false;
		notLoginNotRFQ.value = false;
	} else if (isLogin.value && resultData.isSeeNoBuy == 1) {
		// 与 PC showPrice 一致：可看不可买，已登录用户固定展示「可询价」（不依赖 loginType 2/3 + 控销分支）
		priceShowType.value = 1;
		productShowPrice.value = '可询价';
		isRFQ.value = true;
		notLoginNotRFQ.value = false;
	} else if (
		((loginType.value == 2 || loginType.value == 3) && resultData.isControlSales == 1) ||
		((getReferencePrice(resultData) == 9999999.99 || (!getReferencePrice(resultData) && getReferencePrice(resultData) != 0)) &&
			((!productPrice.value && productPrice.value != 0) || productPrice.value == 9999999.99))
	) {
		priceShowType.value = 1;
		productShowPrice.value = '可询价';
		isRFQ.value = true;
		notLoginNotRFQ.value = false;
	} else {
		priceShowType.value = 2;
		productShowPrice.value = productPrice.value || productPrice.value == 0 ? productPrice.value : getReferencePrice(resultData);
		isRFQ.value = false;
		notLoginNotRFQ.value = false;
	}
}

/** 设置 IPP（集中采购）起购量和倍数约束 */
function resolveIppQuantity(resultData) {
	if (resultData.ippStatus === 101 && resultData.ippMultipleSign) {
		productNum.value = resultData.ippPurchaseMultiple;
	}
	if (resultData.ippStatus === 101 && resultData.ippMiniPurchaseNum) {
		productNum.value = resultData.ippMiniPurchaseNum;
	}
}

/** 根据扩展名判断是否为图片文件 */
function isImageFile(filename) {
	const ext = filename.split('.').pop().toLowerCase();
	return ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff', 'ico'].includes(ext);
}

/** 根据扩展名判断是否为 PDF 文件 */
function isPdfFile(filename) {
	return filename.split('.').pop().toLowerCase() === 'pdf';
}

/** 根据全站列表更新招商等级，再按 loginType/价格/可售 计算展示价与是否可询价 */
async function setProductShowPrice() {
	const websiteRes = await getWebsiteInfoNoLogin(companyId.value);
	if (websiteRes.code == 200 && websiteRes.data) {
		investmentRank.value = websiteRes.data.investmentRank ?? investmentRank.value;
	}
	applyPriceDisplayRules(product.value);
}

/** IPP 商品：根据起购量与倍数规则校验并修正 productNum */
function changeVal(item) {
	if (item.ippStatus === 101 && item.ippMiniPurchaseNum) {
		if (productNum.value < item.ippMiniPurchaseNum) {
			productNum.value = item.ippMiniPurchaseNum;
		} else if (item.ippMiniPurchaseNum) {
			if ((productNum.value - item.ippMiniPurchaseNum) % item.ippPurchaseMultiple > 0) {
				const beis = Math.floor((productNum.value - item.ippMiniPurchaseNum) / item.ippPurchaseMultiple);
				productNum.value = item.ippMiniPurchaseNum + item.ippPurchaseMultiple * beis;
			}
		}
	}
}

/** 点击主图：客户端打开图片预览（轮播图列表） */
function togglePopup(type, open, url) {
	if (import.meta.client) {
		showImagePreview({ images: small.value, startPosition: indexs.value });
	}
}

/** 轮播图切换时更新当前下标 */
function swiperChange(idx) {
	indexs.value = idx;
}

/** 点击证照图片：客户端打开单张图片预览 */
function togglePopup1(type, open, url) {
	if (import.meta.client) {
		showImagePreview({ images: [url], startPosition: 0 });
	}
}

const currentPdfUrl = ref('');
const pdfLoaded = ref(false);
const pdfContainerRef = ref(null);
let pdfViewer = null;

function destroyPdfViewer() {
	if (pdfViewer && typeof pdfViewer.destroy === 'function') {
		pdfViewer.destroy();
	}
	pdfViewer = null;
}

function resolvePdfRenderUrl(pdfUrl) {
	const { hostname } = window.location;
	const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
	return isLocalhost ? `/api/pdf-proxy?url=${encodeURIComponent(pdfUrl)}` : pdfUrl;
}

async function renderPdf(pdfUrl) {
	await nextTick();
	if (!pdfContainerRef.value) return;
	destroyPdfViewer();
	const module = await import('pdfh5');
	const Pdfh5 = module.default || module;
	pdfViewer = new Pdfh5(pdfContainerRef.value, {
		pdfurl: resolvePdfRenderUrl(pdfUrl),
		textLayer: true,
		workerSrc: '/pdfh5/js/pdf.worker.min.js',
		cMapUrl: '/pdfh5/cmaps/',
		standardFontDataUrl: '/pdfh5/standard_fonts/',
		iccUrl: '/pdfh5/iccs/',
		wasmUrl: '/pdfh5/wasm/',
	});
}

/** 点击证照 PDF：在弹框内用 pdfh5/PDF.js 渲染，避免微信 iframe PDF 触发外部打开 */
function gotoLicence(url) {
	if (!import.meta.client) return;
	const pdfUrl = url.ossPath || url;
	if (!pdfUrl) return;
	currentPdfUrl.value = pdfUrl;
	pdfLoaded.value = true;
	showPdf.value = true;
	renderPdf(pdfUrl).catch(error => {
		console.error('[goodDetail] render pdf error:', error);
		vantShowToast({ message: 'PDF加载失败', position: 'bottom' });
	});
}

/** 关闭 PDF 预览 */
function closePdf() {
	destroyPdfViewer();
	showPdf.value = false;
	currentPdfUrl.value = '';
	pdfLoaded.value = false;
}

onBeforeUnmount(() => {
	destroyPdfViewer();
});

/** 打开底部规格/数量弹窗（并重置加购与立即购买标记） */
function toggleBottomOpen() {
	buyNow.value = false;
	cartAddFlag.value = false;
	specsPopupShow.value = true;
}

/** 打开优惠券选择弹窗 */
function chooseCoupon() {
	popOpen.value = true;
	chooseCouponRef.value?.open();
}

/** 关闭规格弹窗 */
function toggleBottomClose() {
	specsPopupShow.value = false;
}

/** 跳转到赠品/推荐商品详情页 */
function toProductDitall(item) {
	const pId = item.productId || item.productid;
	const cId = item.companyId || companyId.value;
	const path = mobileProductDetailPath(cId, pId);
	if (path) navigateTo(path);
}

/** 是否展示优惠券/活动区域（有券或有活动时为 true） */
function isShowCoupon(preferential) {
	return (preferential.couponList && preferential.couponList.length) || preferential.activity;
}

/** 收藏当前商品（未登录跳转登录页） */
function handleFollow(id) {
	if (isLogin.value) {
		addFavoriteList({ productId: id }).then(res => {
			if (res.code == 200) {
				isFollow.value = true;
				vantShowToast({ message: '收藏成功', position: 'bottom' });
			}
		});
	} else {
		window.location.href = '/login';
	}
}

/** 取消收藏当前商品（未登录跳转登录页） */
function handleNotFollow(id) {
	if (isLogin.value) {
		removeFavorite({ productId: id }).then(res => {
			if (res.code == 200) {
				isFollow.value = false;
				vantShowToast({ message: '取消收藏成功', position: 'bottom' });
			}
		});
	} else {
		window.location.href = '/login';
	}
}

/** 请求商品有效期并写入 expireDate（依赖 localStorage 中的 userNo） */
function productExpireDate(data) {
	const user = getStorageSync('user') || {};
	productExpireDateApi({ productCodes: [data.productCode], companyCode: data.filialeCode, customerCode: user.userNo }).then(res => {
		expireDate.value = res.data;
	});
}

const token = useCookie('cmdc_access_token_mobile');

isLogin.value = !!token.value;

productId.value = normalizedRouteProductId;
companyId.value = routeCompanyId;

/**
 * SSR 初始化：请求 /api/goodDetail/full，填充 product / 站点 / 上下文等。
 * 区域价等解析后调用 `applyPriceDisplayRules`，与模板中 `formatPrice(价, 2, isControlSales, isSeeNoBuy)` 对齐。
 */
const initProductDetail = async () => {
	const headers = import.meta.server ? useRequestHeaders(['cookie']) : {};

	const { data: fullRes } = await useAsyncData(`goodDetail-full`, () =>
		$fetch('/api/goodDetail/full', {
			params: { productId: productId.value, companyId: companyId.value },
			headers,
		})
	);

	const payload = fullRes.value?.data;
	gxzzProductAttrSnap.value = normalizeGxzzProductAttrSnap(payload?.productAttrSnap);
	if (!payload?.product) return;

	const result = payload.product;

	// 商品已下架
	if (result.status && result.status == 102) {
		product.value = { ...result, isOffShelf: true };
		return;
	}

	// 从站点列表匹配当前企业
	const siteInfo = payload.siteInfo || payload.context?.siteInfo;
	if (siteInfo && typeof siteInfo === 'object') {
		result.websiteName = siteInfo.websiteName || result.websiteName;
		investmentRank.value = siteInfo.investmentRank ?? 1;
		ssrCompanyCodeRef.value = siteInfo.companyCode ?? null;
	}

	// 填充上下文（SSR 已拉取的接口数据）
	const ctx = payload.context || {};
	if (ctx.discount) {
		if (ctx.discount.couponList)
			ctx.discount.couponList.forEach(item => {
				item.disabled = false;
			});
		preferentialData.value = ctx.discount;
	}
	if (ctx.stockNote != null) stockNote.value = ctx.stockNote;
	if (ctx.isSellCheck != null) result.isSellCheck = ctx.isSellCheck;
	if (ctx.isFavorite != null) isFollow.value = ctx.isFavorite;
	if (ctx.loginTypeSuggest != null) loginType.value = ctx.loginTypeSuggest;
	if (ctx.siteInfo && typeof ctx.siteInfo === 'object') {
		investmentRank.value = ctx.siteInfo.investmentRank ?? investmentRank.value;
	}
	if (Array.isArray(ctx.recommendList)) favoriteList.value = ctx.recommendList.slice(0, 6);

	// 缓存 websiteData，供 onMounted 内 syncLoginTypeFromSSR 写 localStorage（不再请求 queryUserWebsite）
	ssrWebsiteDataRef.value = ctx.websiteData || null;

	// 填充核心响应式数据
	result.defaultImageUrl = result.defaultImageUrl || result?.imageUrls?.[0] || '';
	selectedData1.value[0] = result;
	product.value = result;
	small.value = [...(result.imageUrls || [])];
	isSeeNoBuy.value = result.isSeeNoBuy || 0;

	resolveDistrictPrices(result.agreementPrices, result);
	resolveLicenseInfo(result.licenseInfos);
	applyPriceDisplayRules(result);
	resolveIppQuantity(result);
};

// 所有用户均走 SSR 首屏渲染（server API 内部根据 cookie 自动选择登录/游客接口）
await initProductDetail();

// SEO Meta：利用 SSR 阶段获取的商品数据注入页面元信息
const joinWithSpace = arr => arr.filter(x => !!x).join(' ');

const brand = product.value.seoBrand || product.value.brandName || '';
const productName = product.value.productName || '';
const specs = product.value.specifications || '';
const companyFullName = product.value.companyName || product.value.filialeName || product.value.websiteName || '';
const manufacturer = product.value.manufacturer || '';
const licenseCodeText = product.value.licenseCode || '';
const provinceText = product.value.province || '';

const productCoreText = joinWithSpace([brand, productName, specs]);

const thirdCategoryText = product.value.thirdCategory || product.value.thirdCategoryName || '';

// {品牌} {商品标题} {规格}-{分子公司三级分类}-{公司全称}
const companyCategoryText = thirdCategoryText ? `${thirdCategoryText}` : thirdCategoryText;
const pageTitle = [productCoreText, companyCategoryText, companyFullName].filter(Boolean).join('-');

// {品牌} {商品标题} {规格}，生产厂家：{注册人/备案人}，已取得注册证/备案证：{完整证号}。{品牌} {商品标题} {规格}由{公司全称}官方直营，正品保障，服务{所属省级行政区}地区。
const regionClause = provinceText ? `，服务${provinceText}地区` : '';
const pageDescription = `${productCoreText}，生产厂家：${manufacturer}，已取得注册证/备案证：${licenseCodeText}。${productCoreText}由${companyFullName}官方直营，正品保障${regionClause}。`;

// {品牌}{商品标题}{规格},{所属省级行政区}{三级分类},{公司全称}
const pageKeyword = [
	[brand, productName, specs].filter(Boolean).join(''),
	[provinceText, thirdCategoryText].filter(Boolean).join(''),
	companyFullName,
]
	.filter(Boolean)
	.join(',');

useSeoMeta({
	title: pageTitle,
	ogTitle: pageTitle,
	description: pageDescription,
	ogDescription: pageDescription,
	keywords: pageKeyword,
	ogImage:
		product.value.imageUrls?.[0] ||
		'https://uat-cmdc.oss-cn-beijing.aliyuncs.com/productFile/2022/08/18/9af2756f-27bf-4d1e-b0d1-8397e82bb2a0.png',
});

/** 用 SSR 下发的 websiteData 同步 loginType 到 localStorage，避免客户端再请求 queryUserWebsite */
function syncLoginTypeFromSSR(websiteData) {
	if (!websiteData?.data) return;
	const list = Array.isArray(websiteData.data) ? websiteData.data : [];
	const inItem = list.find(item => item.companyId == companyId.value);
	if (inItem) {
		loginType.value = 4;
		setStorageSync('loginType', 4);
	} else {
		const userInfo = getStorageSync('user') || {};
		const lt = userInfo?.merchantStatus ? 2 : 3;
		loginType.value = lt;
		setStorageSync('loginType', lt);
	}
	const user = getStorageSync('user') || {};
	user.websiteData = websiteData;
	setStorageSync('user', user);
}

// ——— 客户端专属：仅做依赖 DOM / localStorage / 客户端 API 的逻辑，不再请求接口 ———
function onMountedClientOnly() {
	if (!product.value.productId) return;

	// 微信分享（使用 SSR 已有的站点名，无需 getCompanyInfo）
	useWeixin().setShareInfo({
		title: product.value.productName,
		desc: `我正在看【${product.value.websiteName || '国械在线'}】${product.value.productName}，分享给你啦。`,
		img: product.value.imageUrls?.[0],
	});

	// 缓存商品数据到 localStorage（供其他页面读取）
	setStorageSync('product', product.value);
}

/** 计算各模块锚点滚动偏移量（需等待 DOM 渲染完成） */
function calculateScrollOffsets() {
	setTimeout(() => {
		if (!import.meta.client) return;
		const barEl = document.getElementById('barList');
		const barHeight = barEl ? barEl.offsetHeight : 0;
		const labels = controlItems.value;
		sectionStarts.value = labels.map(lab => {
			const id = controlTabToAnchorId(lab);
			const el = document.getElementById(id);
			return el ? el.offsetTop - barHeight : 0;
		});
	}, 500);
}

/** 生命周期：客户端挂载后同步 loginType、站点、分享与浏览历史等，不拉取首屏数据（已由 SSR 完成） */
onMounted(async () => {
	showCustomLoading.value = false;

	isLogin.value = !!getStorageSync('cmdc_access_token_mobile');
	setVisitInfo('商品详情#add#1');
	trackGxzzProductPageEnter();

	// 用 SSR 下发的 websiteData 同步 loginType 到 localStorage，并可能微调 2/3
	if (ssrWebsiteDataRef.value) syncLoginTypeFromSSR(ssrWebsiteDataRef.value);
	const storedLoginType = getStorageSync('loginType');
	if (typeof storedLoginType === 'number') loginType.value = storedLoginType;
	// 若 loginType 被微调，重新计算价格展示
	applyPriceDisplayRules(product.value);

	// 登录用户：同步当前站点（写回，非拉取展示数据）
	if (isLogin.value && ssrCompanyCodeRef.value) {
		await getUserSite({ companyId: companyId.value, companyCode: ssrCompanyCodeRef.value });
	}

	onMountedClientOnly();
	// 到期日依赖 localStorage 中的 userNo，仅客户端可请求
	if (isLogin.value) {
		handleBrowseHistoryAdd();
		productExpireDate(product.value);
	}
	calculateScrollOffsets();
});
</script>

<style lang="scss" scoped>
/* 自定义 loading 遮罩 */
.custom-loading-mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.65);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 99999;
}

.loading-content {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.loading-spinner {
	width: 3rem;
	height: 3rem;
	border: 0.25rem solid #f3f3f3;
	border-top: 0.25rem solid #7c8ffb;
	border-radius: 50%;
	animation: spin 1s linear infinite;
	margin-bottom: 0.8rem;
}

.loading-text {
	color: #ffffff;
	font-size: 16px;
	text-align: center;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

/* 自定义分段 Tab */
.seg-tabs {
	display: flex;
	align-items: center;
	justify-content: space-around;
	height: 3.67rem;
	flex: 1;

	.seg-tab {
		position: relative;
		text-align: center;
		font-size: 1.17rem;
		line-height: 3.67rem;
		color: #181c18;
		cursor: pointer;

		&--active {
			color: #7c8ffb;
			font-weight: bold;

			&::after {
				content: '';
				position: absolute;
				bottom: 4px;
				left: 0;
				right: 0;
				height: 0.25rem;
				background-color: #7c8ffb;
				border-radius: 0.125rem;
			}
		}
	}
}

/* 底部导航栏 */
.goods-nav-bar {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	padding-top: 2px;
	background: #fff;
	padding-bottom: calc(10px + env(safe-area-inset-bottom));
	z-index: 2005;

	.nav-options {
		display: flex;
		align-items: center;
		flex-shrink: 0;
		flex: 1;

		.nav-option-item {
			display: flex;
			flex: 1;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 4rem;
			padding: 6px 0;
			cursor: pointer;
			color: #181c18;
			font-size: 0.75rem;

			i {
				font-size: 1.78rem;
				line-height: 1.78rem;
			}

			span {
				font-size: 10px;
				line-height: 1.5rem;
				color: #222222;
			}
		}
	}

	.nav-buttons {
		flex: 1;
		display: flex;
		padding: 6px 0.83rem;
	}

	.nav-btn {
		height: 44px;
		border: none;
		font-size: 1.17rem;
		color: #fff;
		cursor: pointer;
		font-weight: bold;

		&.btn-cart {
			border-radius: 0.42rem 0 0 0.42rem;
			border: 1px solid #df2737;
			border-right: 0px;
			background: linear-gradient(180deg, #ffffff 0%, #fffcfc 56%, #fff0f2 127%);
			font-size: 1.33333rem;
			color: #db0000;
			line-height: 2rem;
			width: 108px;
		}

		&.btn-buy {
			width: 92px;
			font-size: 1.33333rem;
			line-height: 2rem;
			border-radius: 0 0.42rem 0.42rem 0;
			background: linear-gradient(180deg, #ff5959 -111%, #da1c2c 122%);
		}

		&.btn-consult {
			width: 170px;
			background: #455bd9;
			border-radius: 0.42rem;
			height: 38px;
		}
	}
}

/* 返回按钮 */
.back-btn {
	width: 24px;
	height: 24px;
	border-radius: 100px;
	background: rgba(255, 255, 255, 0.85);
	display: flex;
	align-items: center;
	justify-content: center;
}

.back-btn-fixed {
	position: fixed;
	top: 10px;
	left: 10.5px;
	z-index: 9999;
	cursor: pointer;
}

/* 弹窗 */
.dialogBox {
	position: absolute;
	top: 3rem;
	right: 1rem;
	width: 9.58rem;
	background: #25293c;
	z-index: 111111111111;
	margin-top: 0.4rem;
	border-radius: 0.42rem;

	&:before {
		position: absolute;
		right: 1.15rem;
		top: -0.3rem;
		content: '';
		display: block;
		width: 0.94rem;
		height: 0.94rem;
		z-index: 1111111111;
		background-color: #25293c;
		border-radius: 0.25rem;
		transform: rotate(45deg);
	}
}

/* 页面主结构 */
.goodWrap {
	height: 100vh;
	display: flex;
	flex-direction: column;
	font-family: 'num-fontstyles';
}

.hidePaddingTop {
	padding-top: 0 !important;
}

.scrollContent {
	flex: 1;
	padding-top: 4.16rem;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;

	.contentGood {
		width: 100%;
		margin-bottom: 0.5rem;
		background: #fff;

		.goodBox {
			width: 100%;
			height: 27rem;
			border-bottom: 0.2rem solid #f3f4f6;
			text-align: center;
			position: relative;

			.swiper {
				height: 27rem;

				.swiper-item {
					display: block;
					height: 27rem;
					line-height: 27rem;
					text-align: center;

					img {
						display: block;
						width: 100%;
						height: 100%;
						object-fit: contain;
					}
				}
			}
		}

		.goodTitle {
			border-bottom: 0.2rem solid #f3f4f6;

			.title {
				margin: 0;
				font-size: 1.33rem;
				font-weight: 500;
				color: #222222;
				line-height: 2rem;
			}

			.tag {
				display: inline-block;
				text-align: left;

				.tagtip_red,
				.tagtip_blue,
				.tagtip_bluer,
				.tagtip_green {
					display: inline-block;
					text-align: center;
					margin-left: 0.5rem;
					width: 2.17rem;
					height: 1.08rem;
					line-height: 1.08rem;
					font-size: 0.83rem;
					border-radius: 0.25rem;
				}

				.tagtip_red {
					color: #fff;
					background: #ff5419;
					border: 0.04rem solid #ff5419;
				}

				.tagtip_blue {
					color: #46acdf;
					background: #fff;
					border: 0.04rem solid #46acdf;
				}

				.tagtip_bluer {
					color: #46539d;
					background: #fff;
					border: 0.04rem solid #46539d;
				}

				.tagtip_green {
					color: #5ab355;
					background: #fff;
					border: 0.04rem solid #5ab355;
				}
			}
		}

		.textBox {
			padding: 0.58rem 1.25rem;

			.line {
				position: relative;
				font-size: 1rem;
				font-weight: 400;
				color: #606266;
				line-height: 1.5rem;
				margin-bottom: 0.75rem;

				.line_l {
					display: inline-block;
					font-size: 1rem;
				}

				.line_r {
					display: inline-block;
					height: 1.5rem;
					font-size: 1rem;
					color: #303133;
					line-height: 1.5rem;

					i {
						font-style: normal;
					}

					.to_login {
						font-size: 1rem;
						color: #7c8ffb;
						cursor: pointer;
					}
				}

				.line_goto {
					position: absolute;
					right: 1.25rem;
					top: 0;
					opacity: 0.49;
					font-size: 1rem;
				}
			}

			.line_l.text117 {
				font-size: 1.17rem;
				padding-left: 0.35rem;
			}

			.discount {
				display: inline-block;
				font-style: normal;
				margin-left: 0.5rem;
				margin-right: 1.5rem;
				padding: 0 0.5rem;
				line-height: 1.5rem;
				text-align: center;
				border-radius: 0.25rem;
				border: 0.04rem solid #eb3535;
				font-size: 1rem;
				color: #eb3535;
			}
		}

		.goodActive {
			border-bottom: 0.2rem solid #f3f4f6;
			display: flex;

			.line_l {
				font-size: 1.17rem;
				font-weight: 400;
				color: #606266;
				line-height: 1.67rem;
			}
		}
	}

	.goods-detail {
		margin-top: 0.5rem;
		background: #fff;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.detail-item,
		.detail-item2,
		.detail-item3 {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			padding: 8px 12px;
			align-self: stretch;
			background: #ffffff;
			border-bottom: 1px solid #f3f4f6;

			.label {
				font-size: 12px;
				color: #595959;
				margin-left: 9px;
				line-height: 20px;
			}

			.value {
				font-size: 12px;
				color: #1f1f1f;
				margin-left: 10px;
				line-height: 20px;
			}

			.site-link {
				display: flex;
				flex: 1;
				align-items: center;
				min-width: 0;
				color: inherit;
				text-decoration: none;
			}
		}

		.detail-item {
			height: 32px;
			z-index: 0;
		}

		.detail-item3 {
			align-items: flex-start;
		}
	}

	.purchase-notice-box {
		width: 100%;
		margin-top: 0.5rem;
		background: #fff;

		.purchase-notice {
			font-family: 思源黑体;
			width: 100%;
			padding: 0px 12px 8px 12px;
			font-size: 12px;
			font-weight: normal;
			line-height: 20px;
			color: #595959;
		}
	}

	/* SEO 差异化内容（隐藏但对搜索引擎可见） */
	.seo-footer-content {
		position: absolute;
		left: -9999px;
		top: 0;
		width: 1px;
		height: 1px;
		overflow: hidden;
		font-size: 12px;
		color: #595959;
	}

	.product-msg {
		width: 100%;
		margin-top: 0.5rem;
		background: #fff;

		.detailBox {
			padding: 0 12px 12px 12px;

			img {
				width: 100%;
				display: block;
				height: auto;
			}
		}
	}

	.gxzz-product-info {
		width: 100%;
		margin-top: 0.5rem;
		background: #fff;

		.gxzz-pi-inner {
			padding-bottom: 8px;
		}

		.gxzz-pi-section-head {
			padding: 6px 10px 6px 10px;
			margin: 0 0 10px 12px;
			background: #f2f5fa;
			border-left: 3px solid #455bd9;
			font-size: 13px;
			font-weight: bold;
			color: #1d2129;
		}

		.gxzz-pi-subhead {
			display: flex;
			align-items: center;
			gap: 6px;
			padding: 6px 12px;
			font-size: 12px;
			font-weight: 600;
			color: #333333;

			.iconfont {
				color: #333333;
				font-weight: 400;
				font-size: 14px;
			}
		}

		.gxzz-pi-row {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			gap: 12px;
			padding: 8px 12px;
			border-top: 1px solid #f0f0f0;
			font-size: 12px;
			line-height: 1.5;
		}

		.gxzz-pi-label {
			color: #4b5563;
			flex-shrink: 0;
			max-width: 48%;
		}

		.gxzz-pi-value {
			color: #1f2937;
			text-align: right;
			flex: 1;
		}

		.gxzz-pi-paragraph {
			margin: 0 12px 8px;
			padding: 0 0 8px;
			font-size: 12px;
			line-height: 20px;
			color: #333333;
			border-bottom: 1px solid #f0f0f0;
		}

		.gxzz-pi-package-title {
			margin: 8px 12px 4px;
			font-size: 12px;
			font-weight: 600;
			color: #333333;
		}

		.gxzz-pi-html {
			word-break: break-word;

			:deep(p) {
				margin: 0 0 8px;
			}

			:deep(p:last-child) {
				margin-bottom: 0;
			}
		}
	}

	.content-license {
		width: 100%;
		margin-top: 0.5rem;

		.file-item {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			padding: 8px 12px;
			background: #ffffff;

			.file-box {
				flex: 1;
				min-width: 0;
				display: flex;
				flex-direction: row;
				align-items: center;
				gap: 6px;

				.thumbnail {
					flex-shrink: 0;
					width: 16px;
					height: 16px;
				}

				.liText {
					flex: 1;
					min-width: 0;
					display: block;
				}
			}
		}
	}
}

.detail-title {
	width: 100%;
	height: 37px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 0 12px;
	background: #ffffff;
	font-size: 14px;
	font-weight: bold;
	color: #333333;
}

.price-name {
	font-size: 14px;
	font-weight: bold;
	color: #db0000;
}

.mote-lines-value {
	color: #1f1f1f;
}

.name-wrap {
	display: inline-block !important;
	max-width: 11rem;
	color: #3399ff;
	vertical-align: top;
}

.description {
	width: 95%;
	line-height: 1.6rem;
}

/* 规格弹窗 */
.specifications-content {
	font-family: 'num-fontstyles';
	background-color: #fff;
	border-radius: 7px 7px 0 0;
	padding-bottom: calc(env(safe-area-inset-bottom));

	.popup-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 48px;
		padding: 12px;

		.title {
			flex: 1;
			text-align: center;
			font-size: 18px;
			font-weight: bold;
			color: #333;
		}
	}

	.specifications-box {
		width: 100%;
		margin-bottom: calc(56px + env(safe-area-inset-bottom));

		.product-box {
			width: 100%;
			min-height: 98px;
			display: flex;
			flex-direction: row;
			align-items: center;
			padding: 8px 12px;
			gap: 8px;
			background: #ffffff;

			.img {
				object-fit: contain;
			}

			.product-info {
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: center;

				.title {
					font-size: 13px;
					font-weight: bold;
					color: #333333;
				}

				.specifications {
					font-size: 11px;
					line-height: 15.4px;
					color: #999999;
				}
			}
		}

		.quotation-area {
			width: 100%;
			display: flex;
			flex-direction: column;
			padding: 0px 12px;
			gap: 2px;
			background: #ffffff;

			.quotation-title {
				width: 100%;
				height: 29px;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				padding: 5px 0px;
				font-size: 13px;
				font-weight: bold;
				color: #333333;
			}

			.area-box {
				display: flex;
				flex-direction: row;
				align-items: center;
				padding: 0px;
				gap: 8px 8px;
				flex-wrap: wrap;

				.checkRadio {
					border-radius: 3px;
					display: flex;
					flex-direction: row;
					justify-content: center;
					padding: 7px 8px;
					background: #f0f2f5;
					font-size: 12px;
					color: #595959;
					min-width: 66px;
					cursor: pointer;

					&.checked {
						background: #e5eeff;
						color: #455bd9;
					}
				}
			}
		}

		.quantity-rule {
			width: 100%;
			display: flex;
			flex-direction: column;
			padding: 8px 12px;

			.quotation-num {
				width: 100%;
				height: 29px;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				padding: 5px 0px;
				font-size: 13px;
				font-weight: bold;
				color: #333333;

				.num-title {
					font-size: 10px;
					color: #db0000;
					font-weight: normal;
				}
			}

			.select-num {
				width: 100%;
				display: flex;
				flex-direction: row;
				justify-content: flex-end;
				align-items: center;
				padding-bottom: 8px;
			}
		}
	}
}

/* PDF 预览 */
.pdf-wrap {
	position: fixed;
	width: 100%;
	height: 100%;
	z-index: 12000;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.8);
	user-select: none;
	display: flex;
	flex-direction: column;
}

.pdf-header {
	height: 44px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 0 16px;
	background: #333;

	.icon-guanbi {
		font-size: 1.5rem;
		color: #fff;
		cursor: pointer;
	}
}

.pdf-body {
	height: 0;
	flex: 0 0 0;
	overflow: hidden;
}

.pdf-body--loaded {
	height: calc(100% - 44px);
	flex: 1 1 auto;
}

.pdf-viewer {
	width: 100%;
	height: 100%;
	background: #fff;
}
</style>
